/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Applying 50% off twice is not 100% off — it's 75% off total. The first 50% takes $100 to $50; the second 50% takes $50 to $25, a total drop of 75%, not 100%. Each percentage decrease is calculated from the new, already-reduced value, not the original.`)
};

const es_pct_decrease_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Aplicar un 50% de descuento dos veces no es un 100% de descuento — es un 75% de descuento total. El primer 50% lleva $100 a $50; el segundo 50% lleva $50 a $25, una caída total del 75%, no del 100%. Cada disminución porcentual se calcula sobre el valor nuevo, ya reducido, no sobre el original.`)
};

const de_pct_decrease_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. 50% Rabatt zweimal anzuwenden ergibt nicht 100% Rabatt — insgesamt sind es 75% Rabatt. Die ersten 50% senken $100 auf $50; die zweiten 50% senken $50 auf $25, ein Gesamtrückgang von 75%, nicht 100%. Jeder prozentuale Rückgang wird vom neuen, bereits reduzierten Wert berechnet, nicht vom Original.`)
};

const nl_pct_decrease_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Twee keer 50% korting toepassen is geen 100% korting — het is in totaal 75% korting. De eerste 50% brengt $100 naar $50; de tweede 50% brengt $50 naar $25, een totale daling van 75%, geen 100%. Elke percentagedaling wordt berekend over de nieuwe, al verlaagde waarde, niet over de oorspronkelijke.`)
};

const fr_pct_decrease_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Appliquer 50 % de réduction deux fois ne fait pas 100 % de réduction — cela fait 75 % de réduction au total. Le premier 50 % fait passer 100 $ à 50 $ ; le second 50 % fait passer 50 $ à 25 $, soit une baisse totale de 75 %, pas 100 %. Chaque diminution en pourcentage est calculée à partir de la nouvelle valeur déjà réduite, pas de la valeur d’origine.`)
};

const it_pct_decrease_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Applicare il 50% di sconto due volte non equivale al 100% di sconto — è uno sconto totale del 75%. Il primo 50% porta $100 a $50; il secondo 50% porta $50 a $25, un calo totale del 75%, non del 100%. Ogni calo percentuale viene calcolato sul nuovo valore già ridotto, non su quello originale.`)
};

const pt_br2_pct_decrease_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Aplicar 50% de desconto duas vezes não é 100% de desconto — é 75% de desconto no total. O primeiro 50% leva $100 a $50; o segundo 50% leva $50 a $25, uma queda total de 75%, não de 100%. Cada diminuição percentual é calculada sobre o novo valor, já reduzido, não sobre o original.`)
};

const pt_pct_decrease_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Aplicar 50% de desconto duas vezes não é 100% de desconto — é 75% de desconto total. Os primeiros 50% levam $100 a $50; os segundos 50% levam $50 a $25, uma queda total de 75%, não de 100%. Cada diminuição percentual é calculada a partir do novo valor, já reduzido, e não do original.`)
};

const ja_pct_decrease_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。50%オフを2回適用しても100%オフにはならず、合計では75%オフになります。最初の50%で100ドルが50ドルになり、2回目の50%で50ドルが25ドルになります。合計の下落率は100%ではなく75%です。それぞれのパーセント減少は、元の値ではなく、すでに値下げされた新しい値から計算されるためです。`)
};

const zh_pct_decrease_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不等于。连续两次 50% 折扣不是 100% 折扣——总共是 75% 折扣。第一次 50% 把 $100 降到 $50；第二次 50% 把 $50 降到 $25，总降幅是 75% 而不是 100%。每次百分比减少都是基于新的、已降价的数值计算的，而不是原值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_faq3_a", locale)
	if (locale === "en") return en_pct_decrease_faq3_a(inputs)
	if (locale === "es") return es_pct_decrease_faq3_a(inputs)
	if (locale === "de") return de_pct_decrease_faq3_a(inputs)
	if (locale === "nl") return nl_pct_decrease_faq3_a(inputs)
	if (locale === "fr") return fr_pct_decrease_faq3_a(inputs)
	if (locale === "it") return it_pct_decrease_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_faq3_a(inputs)
	if (locale === "pt") return pt_pct_decrease_faq3_a(inputs)
	if (locale === "ja") return ja_pct_decrease_faq3_a(inputs)
	return zh_pct_decrease_faq3_a(inputs)
};